import LOCATION from '../../../assets/imgs/icon/location.svg';
import { IconButton } from '../../../GlobalComponents/IconButton';
import { useAppDispatch } from '../../../reduxstore/hooks';
import { setStoreSelection } from '../../../domains/UI/store/slice';

export const Icon: React.FC = () => {
	const dispatch = useAppDispatch();

	return (
		<>
			<IconButton
				url={LOCATION}
				alt={'store'}
				onClick={() =>
					dispatch(
						setStoreSelection({
							isOpen: true,
							forSettingOLOStore: true,
							source: 'ICON_BUTTON'
						})
					)
				}
				width={24}
				height={24}
			/>
		</>
	);
};
